import { PaginationMeta } from './pagination';

export enum ActivityLogOwnerType {
  ACCOUNT = 'Account',
  EVENT = 'Event',
  EMPLOYEE = 'Employee',
  CONTACT = 'Contact',
  TASK = 'Task',
}

export type ActivityLog = {
  id: string;
  description: string;
  owner_type: ActivityLogOwnerType;
  owner_id: string;
  owner_uuid: string;
  created_at: string;
  updated_at: string;
  user_id?: string;
  user_email?: string;
  user_uuid?: string;
  employee_display_name?: string;
  employee_avatar_url?: string;
  employee_uuid?: string;
};

export type ActivityLogResponse = {
  data: ActivityLog[];
  meta: PaginationMeta;
};
